// src/utils/checkinCounts.js
// Traffic totals for an open house, derived from the atomic counters the
// kiosk and the +1 buttons keep on the openHouses doc. Totals are always
// derived here, never double-stored.

const n = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

export function deriveTraffic(oh) {
  const people = Math.max(0, n(oh?.manualPeople) + n(oh?.checkinPeople));
  const groups = Math.max(0, n(oh?.manualGroups) + n(oh?.checkinGroups));
  const signedIn = Math.max(0, n(oh?.checkinCount));
  return { people, groups, signedIn };
}

// Groups value for feedback prefill. Null when there is nothing to prefill.
export function feedbackGroups(oh) {
  const g = deriveTraffic(oh).groups;
  return g > 0 ? g : null;
}
